import React                from 'react'
import axios                from 'axios'
import config               from './config'
import $                    from 'jquery'

export default class Layer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deployments: []
    }
    axios.defaults.withCredentials = true
  }

  componentWillMount() {
    this.getOnDemandDeployments().then(resp => {
      this.setState({
        deployments: resp.data.data
      })
      this.$table.DataTable({'paging': false}).column(config.COLUMNS.STATUS).search('').draw()
    })
  }

  getOnDemandDeployments() {
    return axios.get(config.API.ENDPOINT + 'deployments/onDemand').catch(_ => console.log())
  }

  startConsumer(detectionSettingId) {
    return axios.post(config.API.ENDPOINT + 'projects/' + detectionSettingId + '/consume').catch(_ => console.log())
  }

  render() {
    const deployments = this.state.deployments
    var domain = "https://my.visua.com"
    return(
      <div>
        <table 
            ref={(table) => { this.$table = $(table); }}
            className="tbl dataTable" width="100%">
            <thead>
              <tr className="titre">
                <th>Deployment ID</th>
                <th>Project type</th>
                <th>Detection Setting</th>
                <th>Main developer</th>
                <th>Company</th>
                <th>Priority</th>
                <th>Delay</th>
                <th>Throughput</th>
                <th>Outstanding</th>
                <th>Submission Rate</th>
                <th>Processing</th>
                <th>Processed</th>
                <th>Consume</th>
              </tr>
            </thead>
            <tbody>
              {deployments.map(deployment => (
                <tr key={deployment.id}>
                  <td>{deployment.id}</td>
                  <td>{deployment.video ? "video" : "image"}</td>
                  <td className="left" data-order={deployment.detectionSettingId}><a href={domain + "/backoffice/admin/detectionSettings/" + deployment.detectionSettingId}>{deployment.detectionSettingId} - {deployment.detectionSetting.service}</a></td>
                  <td data-order={deployment.detectionSetting.developerId}><a href={domain + "/backoffice/admin/developers/" + deployment.detectionSetting.developerId}>{deployment.detectionSetting.developerId} - {deployment.detectionSetting.developer.name}</a></td>
                  <td data-order={deployment.detectionSetting.developer.company.id}><a href={domain + "/backoffice/admin/companys/" + deployment.detectionSetting.developer.company.id}>{deployment.detectionSetting.developer.company.id} - {deployment.detectionSetting.developer.company.name}</a> </td>
                  <td>{deployment.meta.priority || deployment.meta.priority === 0 ? deployment.meta.priority : 1}</td>
                  <td>{deployment.usage.delay}</td>
                  <td>{deployment.usage.throughput}</td>
                  <td><a href={"https://eu-west-1.console.aws.amazon.com/sqs/v2/home?region=eu-west-1#/queues/https%3A%2F%2Fsqs.eu-west-1.amazonaws.com%2F688887019030%2Fproduction-detection_setting_"+ deployment.detectionSettingId + "_media"}>{deployment.usage.outstanding}</a></td>
                  <td>{deployment.usage.submissionRate}</td>
                  <td>{deployment.usage.processing}</td>
                  <td><a href={"https://eu-west-1.console.aws.amazon.com/sqs/v2/home?region=eu-west-1#/queues/https%3A%2F%2Fsqs.eu-west-1.amazonaws.com%2F688887019030%2Fproduction-detection_setting_"+ deployment.detectionSettingId + "_detections"}>{deployment.usage.processed}</a></td>
                  <td><button onClick={() => this.startConsumer(deployment.detectionSettingId)}>Start consumer</button></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Async.js